<template>
  <div class="block-legal-container">
    <div class="content-container">
      <div
        class="expander"
        :class="{ 'expander--open': expanded }"
        @click="expanded = !expanded"
      >
        <p class="expander__text">{{title}}</p>
        <img src="../images/utils/arrow-down.svg" class="expander__img" alt />
      </div>
      <div
        ref="text"
        class="legal-text-block"
        :class="{ 'legal-text-block--expanded': expanded }"
        v-html="text"
      >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "block-legal",
  components: {},
  directives: {},
  mixins: [],
  props: ['title', 'text'],
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    getLastDayOfMonth(year, month) {
      let date = new Date(year, month + 1, 0);
      return date.getDate();
    },
  },
  watch: {
    expanded(isTextOpened){
      //Плавно открываем и закрываем
      if(isTextOpened){
        this.$refs.text.style.height = this.$refs.text.scrollHeight + 'px'
      } else {
        this.$refs.text.style.height = '0px'
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.block-legal-container {
  font-size: 15px;
  font-weight: 300;
  line-height: 18px;
  width: 100%;
  padding: 26px 20px 41px;
  background-color: #fff;
  position: relative;
}

.content-container {
  max-width: 1110px;
  margin: 0 auto;
}

.expander {
  display: flex;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  transition: 0.3s;

  &:hover{
    color: $primary;
    text-shadow: 1px 1px 1px #000;
  }

  &__text{
    border-bottom: 1px solid $primary;
  }

  &__img{
    width: 20px;
    margin-left: 10px;
    transition: 0.3s;
    rotate: 180deg;
  }

  &--open img {
    rotate: 0deg;
  }
}

.legal-text-block {
  height: 0;
  margin-bottom: 15px;
  overflow-y: hidden;
  transition: 0.6s;

  &--expanded {
    transition: 2.3s;
  }
}

</style>
